module.exports = __webpack_public_path__ + "img/parter-avatar14.9188856a.png";